import { c as _c } from "react/compiler-runtime";
import React, { CSSProperties, useContext } from "react";
import styles from "./GiveBlock.module.scss";
import { WidgetContext } from "../../layout/layout";
import { usePlausible } from "next-plausible";
type GiveBlockProps = {
  heading: string;
  paragraph: string;
  donateLabel: string;
  accentColor?: string;
};
export const GiveBlock: React.FC<GiveBlockProps> = t0 => {
  const $ = _c(19);
  const {
    heading,
    paragraph,
    donateLabel,
    accentColor
  } = t0;
  const [, setWidgetContext] = useContext(WidgetContext);
  const plausible = usePlausible();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let accentStyles = t1;
  if (accentColor) {
    let t2;
    if ($[1] !== accentColor) {
      t2 = {
        "--accent-color": accentColor
      };
      $[1] = accentColor;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    accentStyles = t2 as CSSProperties;
  }
  const buttonClasses = accentColor ? `${styles.button} ${styles.buttonAccent}` : styles.button;
  let t2;
  if ($[3] !== heading) {
    t2 = <h3>{heading}</h3>;
    $[3] = heading;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== paragraph) {
    t3 = <p className="inngress">{paragraph}</p>;
    $[5] = paragraph;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== plausible || $[8] !== setWidgetContext) {
    t4 = e => {
      e.currentTarget.blur();
      plausible("OpenDonationWidget", {
        props: {
          page: window.location.pathname
        }
      });
      plausible("OpenDonationWidgetGiveBlockCTA", {
        props: {
          page: window.location.pathname
        }
      });
      setWidgetContext({
        open: true,
        prefilled: null,
        prefilledSum: null
      });
    };
    $[7] = plausible;
    $[8] = setWidgetContext;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = donateLabel || "Gi.";
  let t6;
  if ($[10] !== accentStyles || $[11] !== buttonClasses || $[12] !== t4 || $[13] !== t5) {
    t6 = <button className={buttonClasses} onClick={t4} style={accentStyles}>{t5}</button>;
    $[10] = accentStyles;
    $[11] = buttonClasses;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t2 || $[16] !== t3 || $[17] !== t6) {
    t7 = <div className={styles.container}>{t2}{t3}{t6}</div>;
    $[15] = t2;
    $[16] = t3;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};